const model = {
	formId: 'resetPassword',
	formField: {
		password: {
			name: 'password',
			label: 'Password',
			requireErrorMsg: 'Password is required',
			value: '',
		},
		confirmPassword: {
			name: 'confirmPassword',
			label: 'Confirm Password',
			requireErrorMsg: 'Confirm Password is required',
			value: '',
		},
	},
};

export default model;